import { useAuthStore } from '@/store/authStore'

/**
 * ¿Puede este asesor vender a clientes reales con margen propio? (docs/120 §3/§6)
 *
 * El MISMO gate sirve para dos cosas: fijar margen y tocar empresas reales — ambas dependen de
 * `Partner.programas.reventaCd2b.habilitado`, que solo se enciende al emitir la primera insignia
 * de certificación (F5). Mientras tanto el asesor sigue teniendo acceso LIBRE a "Mi aprendizaje"
 * y a su empresa demo — eso NUNCA se gatea, así que este hook no lo toca.
 *
 * El dato viaja en la sesión (`login`/`getMe` del portal) para que las 4 pantallas de "Reventa
 * cd-2b" que lo necesitan (Resumen, Mi margen, Mi certificación, Mis ingresos) lean el mismo
 * valor sin un round-trip extra cada una — ver `partnerAuthController.js`.
 */
export function useReventaHabilitada() {
  const partner = useAuthStore((s) => s.partner)
  return !!partner?.programas?.reventaCd2b?.habilitado
}

/**
 * ¿Vende con MARGEN sobre el precio de lista? Desde el 4-oct-2026 los asesores ganan solo comisión
 * (el cliente ve el mismo precio que en el portal); el margen lo enciende un administrador solo
 * para distribuidores formales (docs/cd2b-modelo-comercial-asesores.md D1/D8).
 */
export function useVendeConMargen() {
  const partner = useAuthStore((s) => s.partner)
  const r = partner?.programas?.reventaCd2b
  return !!r?.habilitado && r?.margen === true
}

export default useReventaHabilitada
